import apiClient from './apiClient';

export interface DiaDeFalta {
  data: string;
  falta: boolean;
}

export interface DiaDeExposicaoNoturna {
  data: string;
  exposicaoNoturna: boolean;
}

export interface AttendanceRisk {
  faltas: DiaDeFalta[];
  exposicaoNoturna: DiaDeExposicaoNoturna[];
}

class AttendanceRiskService {
  async getForEmployee(employeeId: number, dias = 30): Promise<AttendanceRisk> {
    const response = await apiClient.get(`/employees/${employeeId}/attendance-risk?dias=${dias}`);
    return response.data;
  }
}

export const attendanceRiskService = new AttendanceRiskService();
export default attendanceRiskService;
